import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  padding: 20px;
  margin: auto;
  border-radius: 8px;
`
export const RulesAndGuidelines = ({ rules }) => {
  return (
    <Container>
      <div dangerouslySetInnerHTML={{ __html: rules }} />
    </Container>
  )
}
